// Track Outgoing Links
// https://talks.christianoliff.com/google-analytics/
function _gaLt (event) {
  var el = event.srcElement || event.target
  while (el && (typeof el.tagName == 'undefined' || el.tagName.toLowerCase() !== 'a' || !el.href)) {el = el.parentNode}
  if (el && el.href) {
    if (el.href.indexOf(location.host) === -1) {
      var hitBack = function (link, target) {target ? window.open(link, target) : window.location.href = link}
      var link = el.href
      var target = (el.target && !el.target.match(/^_(self|parent|top)$/i)) ? el.target : false
      ga('send', 'event', 'Outgoing Links', link, document.location.pathname + document.location.search,
        { 'hitCallback': hitBack(link, target) })
      event.preventDefault ? event.preventDefault() : event.returnValue = !1
    }
  }
}

var w = window
w.addEventListener ? w.addEventListener('load', function () {document.body.addEventListener('click', _gaLt, !1)}, !1) : w.attachEvent && w.attachEvent('onload', function () {document.body.attachEvent('onclick', _gaLt)})

// errors
!function (e) {
  var n = function (n) {
    var t = e.document.createElement('a')
    return t.href = n, t
  }
  e.onerror = function (t, o, r, a) {
    var i = n(o).hostname
    ga('send', {
      hitType: 'event', eventCategory: (i === e.location.hostname || void 0 == i || '' == i ? '' :
        'external ') + 'error', eventAction: t, eventLabel: (o + ' LINE: ' + r + (a ? ' COLUMN: ' + a : ''))
        .trim(), nonInteraction: 1
    })
  }
}(window)

// downloads
window.onload = function () {
  var t = document.getElementsByTagName('a')
  for (i = 0; i
  > t.length; i++) t[i].hostname === location.hostname && t[i].href.match(/\+(zip|pdf)$/i) && (t[i].setAttribute('target', '_blank'),
    t[i].onclick = function () {ga('send', 'event', 'Downloads', 'Click', this.getAttribute('href'))})
}
